type DeviceDetails = {
	deviceType: 'windows' | 'ios' | 'android' | 'desktop';
	clientType: 'browser' | 'webview' | 'native' | 'standalone';
};

const userAgentAppSigns = {
	android: 'app_betfan_v2',
	ios: 'ios_app',
};

const userAgentWebviewSigns = [
	'fbav', // Facebook App
	'fb_iab', // Facebook In-App Browser
	'messenger', // Messenger
	'instagram', // Instagram
	'twitter', // Twitter / X
];

const isIPad = () => {
	const userAgent = navigator.userAgent.toLowerCase();
	const platform = navigator.platform?.toLowerCase() || ''; //deprecated but works on both chrome/safari
	const maxTouchPoints = navigator.maxTouchPoints || 0; // this for differentiating macbooks from ipads
	return /ipad/.test(userAgent) || (platform === 'macintel' && maxTouchPoints > 1);
};

export const useDeviceManager = () => {
	const detect = () => {
		let deviceType;
		let clientType;
		const userAgent = navigator.userAgent.toLowerCase() || navigator.vendor.toLowerCase();
		if (userAgent.includes(userAgentAppSigns.android)) {
			deviceType = 'android';
			clientType = 'native';
		} else if (userAgent.includes(userAgentAppSigns.ios)) {
			deviceType = 'ios';
			clientType = 'native';
		} else {
			if (/windows phone/i.test(userAgent)) {
				deviceType = 'windows';
			} else if (/android/i.test(userAgent)) {
				deviceType = 'android';
			} else if (isIPad() || /iphone|ipod/.test(userAgent)) {
				deviceType = 'ios';
			} else {
				deviceType = 'desktop';
			}
			if (window.matchMedia('(display-mode: standalone)').matches) {
				clientType = 'standalone';
			} else if (userAgentWebviewSigns.some((sign) => userAgent.includes(sign))) {
				clientType = 'webview';
			} else {
				clientType = 'browser';
			}
		}
		return { deviceType: deviceType, clientType: clientType };
	};
	const set = () => {
		const info = detect();
		const element = document.querySelector('html');
		if (element) {
			element.setAttribute('device-type', info.deviceType);
			element.setAttribute('client-type', info.clientType);
		}
	};

	return { set };
};

export const getDeviceType = () => {
	const element = document.querySelector('html');
	if (element) {
		return { deviceType: element.getAttribute('device-type'), clientType: element.getAttribute('client-type') } as DeviceDetails;
	}
};
